import { Radio } from "antd";
import { FC } from "react";
import {
  ActiveBothGendersSVG,
  ActiveManSVG,
  ActiveWomanSVG,
  nonActiveBothGendersSVG,
  nonActiveManSVG,
  nonActiveWomanSVG,
} from "../../assets/SVGs/SVGs";

interface GenderSwitchProps {
  string: any;
  gender: "male" | "man" | "men" | "female" | "woman" | "both";
  active: boolean;
  disabled?: boolean;
}

const GenderSwitch: FC<GenderSwitchProps> = ({
  active,
  gender,
  string,
  disabled = false,
}) => {
  let svg = <></>;

  if (gender === "male" || gender === "man") {
    if (active) {
      svg = ActiveManSVG;
    } else {
      svg = nonActiveManSVG;
    }
  } else if (gender === "female" || gender === "woman") {
    if (active) {
      svg = ActiveWomanSVG;
    } else {
      svg = nonActiveWomanSVG;
    }
  } else if (gender === "both") {
    if (active) {
      svg = ActiveBothGendersSVG;
    } else {
      svg = nonActiveBothGendersSVG;
    }
  }
  console.log(active);

  return (
    <>
      <Radio.Button
        disabled={disabled}
        className={`radioGender ${active && "!bg-white !shadow-sm"} ${
          disabled && "cursor-default"
        } `}
        value={gender}
      >
        <div
          className={`flex font-semibold items-center gap-1 activeSvg whitespace-nowrap capitalize ${
            active && "!text-color-primary"
          }`}
        >
          {svg}
          {string}
        </div>
      </Radio.Button>
    </>
  );
};

export default GenderSwitch;
